const type = 'SET_MOBILE_DETECTION';

const setMobileDetection = (data) => ({
  type,
  data,
});

export { type };
export default setMobileDetection;
